const $$splitComponentImporter = () => import('/home/runner/work/inspecttec-frontend-admin/inspecttec-frontend-admin/src/routes/client/groups/create.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { Permissions } from "@/constants/permissions";
import { requirePermission } from "@/lib/auth/permission-guard";
import { UserGroupType } from "@/types/api/user-group";
import { createFileRoute } from "@tanstack/react-router";
import * as z from "zod";
export const Route = createFileRoute("/client/groups/create")({
  beforeLoad: args => requirePermission(Permissions.Support.ViewClientData, args),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});

// ... (Schema implementation below)
const groupSchema = z.object({
  userGroupName: z.string().min(1, "Group name is required"),
  userGroupType: z.nativeEnum(UserGroupType, {
    errorMap: () => ({
      message: "Please select a group type"
    })
  }),
  isActive: z.boolean().default(true)
});
type GroupFormValues = z.infer<typeof groupSchema>;